module.exports = __webpack_public_path__ + "img/security-code.2addcb20.svg";